import React from "react";
import PropTypes from "prop-types";
import { useTrans, useFeatureFlags } from "../../hooks";
import { CatalogHeader } from "./CatalogHeader";
import { PaidStoriesCatalog } from "./catalogs/PaidStoriesCatalog";
import PremiumPicksCatalog from "./catalogs/PremiumPicksCatalog";

function Catalog({ catalog, isMobile }) {
  const { trans } = useTrans();
  const featureFlags = useFeatureFlags();
  const catalogTitle = featureFlags?.PAID_REPACKAGING
    ? trans("Wattpad Originals")
    : trans("Paid Stories");

  switch (catalog) {
    case "paidstories":
    case "wattpadoriginals":
      return (
        <div className="catalog-container">
          <CatalogHeader
            title={catalogTitle}
            catalog={catalog}
            isMobile={isMobile}
          />
          <PaidStoriesCatalog />
        </div>
      );
    case "premiumpicks":
      return <PremiumPicksCatalog />;
  }

  return null;
}

Catalog.propTypes = {
  catalog: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export { Catalog };
